/* Product page: configurator on real Shopify variants + Print.App editor mounted in the cart form. */
(function () {
  'use strict';
  const boot = () => {
    const A1 = window.A1, $ = A1.$, esc = A1.esc, money = A1.money;
    const pdp = $('pdp'); if (!pdp) return;
    const p = A1.product || A1.byHandle(pdp.dataset.handle); if (!p) return;
    const T = typeof TEMPLATES !== 'undefined' ? TEMPLATES : (window.TEMPLATES || {});
    if (!p.designs) { p.designs = (T[p.handle] || []).map(([id, img, name]) => ({ id, name, url: 'https://d1p81tn8mwpox2.cloudfront.net/?k=s3%3A%2F%2Fapp-print-cdn%2Fpreview_content_' + img + '.png&size=700' })); p.qi = p.options.findIndex(o => o.name === 'Quantity'); }
    const form = $('productForm');

    /* gallery */
    const thumbs = $('pgThumbs');
    if (thumbs) thumbs.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; [...thumbs.children].forEach(x => x.classList.toggle('on', x === b)); $('pgMain').src = b.dataset.src; });

    /* options, quantity, price */
    A1.renderOpts($('pOpts'), p, 'p');
    const { input } = A1.qtyUI($('pQtyWrap'), p);
    if (!input.hidden) input.value = p.min > 1 ? p.min : 1;
    /* OPTIS Product Options (the shop's add-on options: paper, sides, folds, bundling…) mounts itself
       inside this form. Keep it after the variant selects and fold its surcharges into the price. */
    let optis = null;
    const placeOptis = () => {
      const po = form.querySelector('.bss-po-product-page'); if (!po || po === optis) return;
      optis = po; const anchor = $('pOpts'); if (anchor && po.previousElementSibling !== anchor) anchor.after(po);
      po.addEventListener('change', () => setTimeout(price, 50)); po.addEventListener('click', () => setTimeout(price, 150));
      pdp.classList.add('has-optis'); price();
    };
    /* OPTIS pricing model: some option values (paper, sides, ink, folds) carry their own quantity box and are
       charged unit price × that box; the rest (bundling, perforation) are flat. At checkout OPTIS adds its
       "extra" to the unit price and Shopify multiplies by the line quantity. So: the boxes mirror the order
       quantity (and stay hidden), and for per-unit products the extra is handed back per unit. */
    const optisBox = id => form.querySelector(`.bss-po-product-page input.quantity-input[name="quantity${id}"]`);
    const extras = () => {
      try {
        const o = window.BSS_PO && window.BSS_PO.currentSelectedOptions; if (!o || !o.allValues) return { per: 0, flat: 0 };
        let per = 0, flat = 0;
        o.allValues.forEach(v => { if (!v.value || !v.unitPrice) return; if (optisBox(v.id)) per += +v.unitPrice || 0; else flat += +v.unitPrice || 0; });
        return { per, flat };
      } catch (e) { return { per: 0, flat: 0 }; }
    };
    const syncOptisQty = qty => form.querySelectorAll('.bss-po-product-page input.quantity-input').forEach(i => { if (+i.value !== qty) { i.value = qty; i.dispatchEvent(new Event('change', { bubbles: true })); } });
    window.bssFixSupportCustomExtraPriceForKeepPriceWhenChangeQuantity = (extra, qty) => { const q = +qty || 1; return q > 1 ? Math.round((+extra || 0) / q * 10000) / 10000 : extra; };
    window.bssFixSupportCustomAfterAddToCart = (t, res, btn, f) => {
      try { t.helper.removeLoadingBtnCSS(btn, f); } catch (e) {}
      if ($('cartOv').hidden) { A1.cart.fetch(); A1.open('cartOv'); A1.toast('Added to your bag'); }
    };
    function price() {
      const sel = A1.readOpts($('pOpts'), p), tier = form.querySelector('select.tier');
      if (p.qi >= 0 && tier) sel[p.qi] = tier.value;
      const r = A1.priceFor(p, sel, +input.value || 1);
      $('pVariant').value = r.v.id;
      syncOptisQty(r.qty);
      const x = extras(), perC = Math.round(x.per * 100), flatC = Math.round(x.flat * 100), addon = perC * r.qty + flatC, total = r.total + addon;
      $('pTotal').textContent = money(total);
      $('pUnit').textContent = `${r.qty.toLocaleString()} × ${r.unit}` + (perC ? ` + ${money(perC)} options each` : '') + (flatC ? ` + ${money(flatC)} finishing` : '');
      $('pMin').textContent = (p.min > 1 ? `Minimum ${p.min}. ` : '') + (r.v.available ? 'Standard production 4 to 7 business days after proof approval.' : 'This option is currently unavailable.');
      $('addBtn').disabled = !r.v.available;
      return r;
    }
    form.addEventListener('input', e => { if (e.target.closest('#pOpts, #pQtyWrap')) price(); });
    form.addEventListener('change', e => { if (e.target.closest('#pOpts, #pQtyWrap')) price(); });
    (function fromUrl() {
      const q = new URLSearchParams(location.search);
      const vid = q.get('variant'), v = vid && p.variants.find(x => String(x.id) === vid);
      if (v) { v.opts.forEach((val, i) => { const s = $('pOpts').querySelector(`select[data-i="${i}"]`); if (s) s.value = val; const tier = form.querySelector('select.tier'); if (i === p.qi && tier) tier.value = val; }); }
      if (q.get('quantity') && !input.hidden) input.value = Math.max(+q.get('quantity') || 1, p.min || 1);
      if (q.get('turn')) { const r = form.querySelector(`input[name="properties[Turnaround]"][value="${CSS.escape(q.get('turn'))}"]`); if (r) r.checked = true; }
      if (q.get('mode') === 'file') { pdp.classList.add('file-mode'); setTimeout(() => { const up = form.querySelector('.bss-po-product-page input[type=file]') || form; (up.closest('.po-option--container') || up.closest('[class*="po-option"]') || up).scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 1800); }
      if (q.has('mode') || q.has('turn') || q.has('quantity')) { const u = new URL(location.href); ['mode', 'turn', 'quantity'].forEach(k => u.searchParams.delete(k)); history.replaceState(null, '', u.href); }
    })();
    price();
    // OPTIS adds or removes its per-option quantity boxes as values change; keep them in step with the order quantity
    let boxSig = '';
    new MutationObserver(() => {
      placeOptis(); if (!optis) return;
      const sig = [...form.querySelectorAll('.bss-po-product-page input.quantity-input')].map(i => i.name).join(',');
      if (sig !== boxSig) { boxSig = sig; price(); }
    }).observe(form, { childList: true, subtree: true }); placeOptis();

    /* add to bag. With OPTIS mounted, its own handler owns the add (it validates required options and
       carries the surcharges to checkout); we just watch the cart request and open the drawer. */
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (optis) return; // OPTIS intercepts the button click before a submit can happen; this is a keyboard fallback
      const r = price();
      if (!r.pack && (+input.value || 0) < p.min) { input.value = p.min; price(); }
      const btn = $('addBtn'); btn.disabled = true; btn.firstElementChild.textContent = 'Adding…';
      try {
        const fd = new FormData(form); fd.delete('form_type'); fd.delete('utf8');
        await A1.cart.add(fd);
        A1.open('cartOv'); A1.toast('Added to your bag');
      } catch (err) { A1.toast(err.message || 'Could not add to bag'); }
      btn.disabled = false; btn.firstElementChild.textContent = 'Add to bag';
    });
    form.addEventListener('click', e => { if (optis && e.target.closest('#addBtn, .po-atc-btn')) { const r = price(); if (!r.pack && (+input.value || 0) < p.min) { input.value = p.min; price(); } } }, true);
    document.addEventListener('a1:cart:added', () => { A1.open('cartOv'); A1.toast('Added to your bag'); });

    /* Print.App */
    const own = $('openDesign');
    const picking = p.designs.length > 1;
    if (p.designs.length) { pdp.classList.add('has-designs'); if (picking) { own.hidden = false; pdp.classList.add('picking'); } }
    // Print.App's command button wording → the shop's voice
    const relabel = () => document.querySelectorAll('#pa-buttons .printapp-commands > button').forEach(b => { const t = b.textContent.trim(); if (/personali[sz]e design/i.test(t)) b.textContent = 'Design online'; else if (/^resume design$/i.test(t)) b.textContent = 'Edit your design'; else if (/^clear$/i.test(t)) b.textContent = 'Start over'; });
    new MutationObserver(relabel).observe(form, { childList: true, subtree: true, characterData: true });
    let instance = null, waited = 0;
    const want = new URLSearchParams(location.search).get('pa_design');
    if (want) { const u = new URL(location.href); u.searchParams.delete('pa_design'); history.replaceState(null, '', u.href); }
    const show = designId => {
      if (!instance) { A1.toast('The editor is still loading, one moment…'); return; }
      try { instance.showApp(designId ? { designId } : undefined); } catch (e) { console.error(e); }
    };
    const choose = () => picking ? A1.openPicker(p, show) : show(p.designs[0] && p.designs[0].id);
    own.addEventListener('click', choose);
    A1.launchInline = (prod, designId) => { if (prod.handle !== p.handle) return false; designId ? show(designId) : choose(); return true; };
    const saved = () => { pdp.classList.remove('picking'); $('designed').classList.add('on'); own.hidden = true; $('addBtn').classList.remove('ghost'); $('designed').scrollIntoView({ behavior: 'smooth', block: 'center' }); };
    $('editAgain').addEventListener('click', () => show());
    const attach = () => {
      instance = window.printAppInstance;
      try { instance.on('app:saved', saved); } catch (e) { try { instance.addEventListener('app:saved', saved); } catch (e2) {} }
      try { const st = JSON.parse(localStorage.getItem('print-app-sp') || '{}'); if (st[String(p.id)] && st[String(p.id)].projectId && st[String(p.id)].action !== 'reorder') saved(); } catch (e) {}
      // Print.App's own command button duplicates ours while a template is still to be chosen
      if (want) setTimeout(() => show(want), 600);
    };
    const poll = setInterval(() => { if (window.printAppInstance) { clearInterval(poll); attach(); } else if ((waited += 250) > 20000) clearInterval(poll); }, 250);
    // route clicks on Print.App's own "Personalise" button through our template picker
    form.addEventListener('click', e => {
      const b = e.target.closest('#pa-buttons .printapp-commands > button'); if (!b || !picking || !pdp.classList.contains('picking')) return;
      if (b.dataset.cmd) return;
      e.preventDefault(); e.stopImmediatePropagation(); choose();
    }, true);
  };
  if (window.A1 && window.A1.cart) boot(); else document.addEventListener('a1:ready', boot, { once: true });
})();
